import { Fab } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";

interface Props {
  onClick: () => void;
}

const ArchieButton = ({ onClick }: Readonly<Props>) => {
  return (
    <Fab
      color="primary"
      aria-label="Open Archie chat"
      onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1100,
      }}
    >
      <ChatIcon />
    </Fab>
  );
};

export default ArchieButton;
